import { getAPIUrl } from "../config";

const API_URL = getAPIUrl();

const authedFetch = async (getAccessTokenSilently, path, options = {}) => {
  const token = await getAccessTokenSilently();
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || `Request failed (${response.status})`);
  }

  return response.json();
};

export const fetchDashboardStatistics = async (venueId, range, getAccessTokenSilently) =>
  authedFetch(
    getAccessTokenSilently,
    `/api/v1/venues/${venueId}/statistics/dashboard?range=${encodeURIComponent(range)}`,
    { method: "GET" },
  );
